// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"205":"record_detailed","334":"artface","922":"edit","926":"record"}[chunkId] + "." + {"205":"e257c66b","334":"155f4a3e","922":"69ba574f","926":"51f9489a"}[chunkId] + ".js";
};